import nl from './nl'
import Utils from '../Utils'

var nlMsg = {
  'agreements.title': 'Aanvaardingen',
  'agreements.error.mandatory': "U moet aanvaarden om de diensten van Deeper te blijven gebruiken",
  'agreements.error.blank': "Maak een keuze",
  'agreements.back': 'Terug',
  'agreements.agree': 'Aanvaarden',
  'agreements.decline': 'Weigeren',
  'agreements.text.full': 'Volledige aanvaarding'
}

Utils.addTerms(nlMsg, nl)

export default nlMsg



// WEBPACK FOOTER //
// ./src/lang/nlMsg.js